import { render } from "./head.vue?vue&type=template&id=0c6aa364"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"

import "./head.vue?vue&type=style&index=0&id=0c6aa364&lang=scss"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__